import { Component, Input, OnInit } from '@angular/core';
import { AbstractAuditableDto } from '@sharedrest/data.restservice';

@Component({
  selector: 'neq-event-list',
  templateUrl: './event-list.component.html'
})
export class NeqEventListComponent implements OnInit {

  @Input() auditableDto: AbstractAuditableDto;

  ngOnInit() {
    // Required
   }

}
